import "../../Styling/Header.css";
import { trustedData } from "../../Data/ShowcaseData";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/favicon.png";

const Header = () => {
  const trustedDataValues = [...Object.values(trustedData)];

  let navigate = useNavigate();

  return (
    <div>
      <div className="header-wrapper">
        <img className="image-logo" src={logo} alt="" />
        <h1 className="header-title">
          Where Ideas Meet Real-World Products.
        </h1>
        <h4 className="header-subtitle">
          Launched over 200+ iOS, Android & Web apps.
        </h4>
        <div className="header-button-wrapper">
          <button
            className="header-button-one"
            onClick={(e) => {
              e.preventDefault();
              navigate("contact");
            }}
          >
            Contact Us
          </button>
        </div>
        {/* Trusted */}
        <div className="header-trusted-wrapper">
          <p className="header-trusted-wrapper-title">Trusted by companies</p>
          <div className="trusted-images-wrapper">
            {trustedDataValues.map((item, idx) => (
              <img
                key={idx}
                className="trusted-image"
                alt=""
                src={item.imgUrl}
                style={{ objectFit: "cover", height: "100%"}} // Make sure the image fills the container
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
